import maintainRequest from "@/maintain/utils/maintainRequest";

export function login(params) {
  return maintainRequest({
    url: "/user/oauth/token",
    method: "post",
    params,
  });
}
